import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'

import { Integration, IntegrationModelData, IntegrationUpdateResponse } from '@shared/models/integration.model'
import { ApiService } from '@shared/services/api.service'

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  constructor(private apiService: ApiService) {}

  integrationsList(teamId: number): Observable<Integration[]> {
    return this.apiService.get(`/integrations/team/${teamId}`, { responseType: 'json' })
  }

  integrationById(id: number, teamId: number): Observable<IntegrationModelData> {
    return this.apiService.get(`/integrations/${id}/team/${teamId}/data`, { responseType: 'json' })
  }

  editIntegrationStatus(id: number, teamId: number, status: string): Observable<IntegrationUpdateResponse> {
    return this.apiService.post(`/integrations/${id}/team/${teamId}/status`, { status })
  }

  saveIntegrationData(id: number, teamId: number, data: Pick<IntegrationModelData, 'data'>): Observable<IntegrationUpdateResponse> {
    return this.apiService.post(`/integrations/${id}/team/${teamId}/data`, data)
  }

  saveIntegrationScope(id: number, teamId: number, scope: Pick<IntegrationModelData, 'scope'>): Observable<IntegrationUpdateResponse> {
    return this.apiService.post(`/integrations/${id}/team/${teamId}/scope`, scope)
  }
}
